import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id E7FCE878-E3CA-4EF8-B0B5-D926ACE33122
 * name size-xl
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/size-xl.svg
 * tags
 */
export const SizeXlIcon = createSvgIcon(<><path d="M6 7H8L9 9.5L10 7H12L10 12L12 17H10L9 14.5L8 17H6L8 12L6 7M13 7H15V15H19V17H13V7Z" /></>, 'SizeXlIcon');
export default SizeXlIcon